module.exports = __webpack_public_path__ + "static/media/texture-square.9511caa6.png";